import React, { useState, useEffect } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import ColorLineText from '../../atoms/Text/ColorLineText';
import * as Constant from '../../../Constant';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(
  createStyles({
    tableStyle: {
      borderWidth: '1px',
      borderColor: '#aaaaaa',
      borderStyle: 'solid',
      background: '#e0e0e0',
      borderCollapse: `collapse`,
      width: '150px',
    },
    tdStyle: {
      borderWidth: '1px',
      borderColor: '#aaaaaa',
      borderStyle: 'solid',
      background: '#e0e0e0',
      padding: '0px',
    },
    tdCheckStyle: {
      borderWidth: '1px',
      borderColor: '#aaaaaa',
      borderStyle: 'solid',
      background: '#e0e0e0',
      padding: '2px',
    },
  })
);

const RealTimeTrendGraphItemInfoHeader: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const backColor = '#e0e0e0';

  return (
    <table className={classes.tableStyle}>
      <tr>
        <td className={classes.tdCheckStyle}>{t('RealTimeTrendGraphItemInfoHeader.表示 有', '表示 有')}</td>
        <td className={classes.tdCheckStyle}>{t('RealTimeTrendGraphItemInfoHeader.線色', '線色')}</td>
      </tr>
      <tr>
        <td className={classes.tdStyle} colSpan={2}>
          {t('RealTimeTrendGraphItemInfoHeader.計測種別', '計測種別')}
        </td>
      </tr>
      <tr>
        <td className={classes.tdStyle} colSpan={2}>
          {t('RealTimeTrendGraphItemInfoHeader.機器番号_機器名称', '機器番号・機器名称')}
        </td>
      </tr>
      <tr>
        <td className={classes.tdStyle} colSpan={2}>
          {t('RealTimeTrendGraphItemInfoHeader.項目名称', '項目名称')}
        </td>
      </tr>
      <tr>
        <td className={classes.tdStyle}>{t('RealTimeTrendGraphItemInfoHeader.データ種別', 'データ種別')}</td>
        <td className={classes.tdStyle}>{t('RealTimeTrendGraphItemInfoHeader.単位', '単位')}</td>
      </tr>
      <tr>
        <td className={classes.tdStyle} colSpan={2}>
          {t('RealTimeTrendGraphItemInfoHeader.異常種別', '異常種別')}
        </td>
      </tr>
      <tr>
        <td className={classes.tdStyle}>
          {t('RealTimeTrendGraphItemInfoHeader.軽故障', '軽故障')}{' '}
          <ColorLineText width={'20px'} color={Constant.LIGHT_FAULT_LINE_COLOR} height={'2px'} />
        </td>
        <td className={classes.tdStyle}>
          {t('RealTimeTrendGraphItemInfoHeader.重故障', '重故障')}{' '}
          <ColorLineText width={'20px'} color={Constant.SERIOUS_FAULT_LINE_COLOR} height={'2px'} />
        </td>
      </tr>
    </table>
  );
};

export default RealTimeTrendGraphItemInfoHeader;
